﻿import React, {Component} from "react";

export class Indicator extends Component {
    render() {
        return <span className={"indicator"}/>
    }
}